import React, { useEffect } from 'react';

import { Stack } from '@lyearn/ui';
import { ResourceReviewTypeEnum, ReviewerConfigInput, ReviewerTypeEnum } from '@/types/schema';

import ReviewerSettings from './ReviewerSettings';

type SubmissionReviewProps = {
  reviewType: ResourceReviewTypeEnum;
  reviewerConfig: ReviewerConfigInput;
  showError?: boolean;
  isEditMode: boolean;
  initialReviewerConfig: ReviewerConfigInput;
  onReviewerConfigChange: (nextValue: ReviewerConfigInput) => void;
  view?: 'modal' | 'form';
};

function SubmissionReview({
  reviewType,
  reviewerConfig,
  showError,
  initialReviewerConfig,
  isEditMode,
  onReviewerConfigChange,
  view = 'form',
}: SubmissionReviewProps) {
  useEffect(() => {
    if (
      reviewType === ResourceReviewTypeEnum.OptionalReview &&
      reviewerConfig.type === ReviewerTypeEnum.Peer
    ) {
      onReviewerConfigChange({ ...reviewerConfig, type: ReviewerTypeEnum.Specific });
    }
  }, [onReviewerConfigChange, reviewType, reviewerConfig]);

  return (
    <Stack direction="col">
      <ReviewerSettings
        initialReviewerConfig={initialReviewerConfig}
        isEditMode={isEditMode}
        reviewType={reviewType}
        reviewerConfig={reviewerConfig}
        showError={showError}
        view={view}
        onReviewerConfigChange={onReviewerConfigChange}
      />
    </Stack>
  );
}

export default React.memo(SubmissionReview);
